import React from "react";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import { Url, formatTimestamp, getAdjustedPrice, security_key } from "../../Services/Api";
import "../Page.css";
import "./style.css";
import CategoryCard from "./priceTagComponents/categoryCards";
import ProductCard from "./priceTagComponents/productCard";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import jsPDF from "jspdf";
import { generatePDF } from "./priceTagsPdf/pdfOption1";
import banner1 from "../../Assets/ptags/banners/1.jpg"
import banner2 from "../../Assets/ptags/banners/4.jpg";
import { IoSettingsOutline } from "react-icons/io5";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import { FiUpload } from "react-icons/fi";
import searchIcon from "../../Assets/Images/Search Bar 20 x 20.png";

import { RxCross1 } from "react-icons/rx";
import { IoClose } from "react-icons/io5";
import { generatePDF1 } from "./priceTagsPdf/blankPdfF1";
import { generatePDF2 } from "./priceTagsPdf/blankPdfF2";
import { generatePDF3 } from "./priceTagsPdf/blankPdfF3";
import { generatePDFOpt2 } from "./priceTagsPdf/pdfOption2";
import { generatePDFOpt2_TwoCols } from "./priceTagsPdf/pdfOption3";
import SearchBar from "../../Components/UI-Controls/SearchBar/Search";
import SearchMultiple from "../../Components/UI-Controls/MultiSelect/Multiselect";
import CustomCheckbox from "../../Components/CustomCheckBox/CustomCheckbox";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";
import { generatePDFWithoutFinanceBox } from "./priceTagsPdf/pdfOption0_copy";
import { IoChevronForward } from "react-icons/io5";
import { IoChevronBack } from "react-icons/io5";
import { generatePDFOpt3_TwoCols } from "./priceTagsPdf/pdfOption4";
import { generatePDFOpt3_TwoCols_2 } from "./priceTagsPdf/pdfOption1_copy";
import { generatePDFOpt4_TwoCols_2 } from "./priceTagsPdf/pdfOption2_copy";
import { format } from "date-fns";




const PriceTags = () => {

  const scrollRef_2 = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const handleScroll = (direction) => {
    if (!scrollRef_2.current) return;
    const scrollAmount = 250;
    const el = scrollRef_2.current;

    if (direction === "left") {
      el.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else {
      el.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }

    // ✅ Manually re-check after short delay (smooth scroll timing)
    setTimeout(() => checkScroll(), 300);
  };

  const checkScroll = () => {
    const el = scrollRef_2.current;
    if (!el) return;

    const { scrollLeft, scrollWidth, clientWidth } = el;

    // Add a small tolerance because of rounding issues
    const atStart = scrollLeft <= 2;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;

    setCanScrollLeft(!atStart);
    setCanScrollRight(!atEnd);
  };


  useEffect(() => {
    const el = scrollRef_2.current;
    if (!el) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    const startDragging = (e) => {
      isDown = true;
      el.classList.add("dragging");
      startX = e.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    };

    const stopDragging = () => {
      isDown = false;
      el.classList.remove("dragging");
    };

    const onDrag = (e) => {
      if (!isDown) return;
      e.preventDefault(); // prevent text selection
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.5; // scroll speed multiplier
      el.scrollLeft = scrollLeft - walk;
      checkScroll(); // update arrow state while dragging
    };

    el.addEventListener("mousedown", startDragging);
    el.addEventListener("mouseleave", stopDragging);
    el.addEventListener("mouseup", stopDragging);
    el.addEventListener("mousemove", onDrag);

    return () => {
      el.removeEventListener("mousedown", startDragging);
      el.removeEventListener("mouseleave", stopDragging);
      el.removeEventListener("mouseup", stopDragging);
      el.removeEventListener("mousemove", onDrag);
    };
  }, []);







  const [productsCache, setProductsCache] = useState({});
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showBannerSelection, setShowBannerSelection] = useState(false);
  const [showPatternSelection, setShowPatternSelection] = useState(false);
  const [showPatternSelection2, setShowPatternSelection2] = useState(false);
  const [subLoading, setSubLoading] = useState(false);
  const [showFobPrice, setShowFobPrice] = useState(false);
  const [showLandedCost, setShowLandedCost] = useState(false);
  const [selectedStock, setSelectedStock] = useState(null);

  const statusTypeOptions = [
    { value: "recent", label: "Recent" },
    { value: "price_high_to_low", label: "Price (High to Low)" },
    { value: "price_low_to_high", label: "Price (Low to High)" },
    { value: "alphabetic_a_to_z", label: "Alphabetic (A to Z)" },
    { value: "alphabetic_z_to_a", label: "Alphabetic (Z to A)" }
  ];


  const [selectedSortingOption, setSelectedSortingOption] = useState(null)


  const stockOptions = [
    { value: "1", label: "In stock" },
    { value: "0", label: "Out of Stock" }
  ];




  const [selectedCategory, setSelectedCategory] = useState({
    name: "",
    uid: null,
    slug: "",
    subCategories: []
  });
  const [selectedSubCategory, setSelectedSubCategory] = useState({
    name: "",
    uid: null,
    slug: ""
  });

  const [ptagCategoriesData, setPtagCategoriesData] = useState([]);

  const fetchPtagCategories = async () => {
    setLoading(true);
    const token = sessionStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key
    };
    try {
      const response = await axios.get(`${Url}/api/v1/ptag/get-detailed`, { headers: headers });
      const getAllMainCategories = response.data?.data || [];
      setPtagCategoriesData(getAllMainCategories);
      console.log(getAllMainCategories);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMainCategories = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${Url}/api/v1/productCategory/get?parent=0&menu_order=1`);
      const getAllMainCategories = response.data.categories || [];
      setCategories(getAllMainCategories);
      console.log(getAllMainCategories);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };




  const [bannersMedia, setBannersMedia] = useState([]);
  const fetchBannersMedia = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${Url}/api/v1/media/price-tags/get`);
      const getAllMediaBanners = response.data.data || [];
      setBannersMedia(getAllMediaBanners);
      setSelectedBannerImage(getAllMediaBanners[0])
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };



  const fetchSubCategories = async (parent) => {
    setLoading(true);
    try {
      const response = await axios.get(`${Url}/api/v1/productCategory/get?parent=${parent}`);
      const getAllMainCategories = response.data.categories || [];
      setSubCategories(getAllMainCategories);
      console.log(getAllMainCategories);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [pagination, setPagination] = useState({
    currentPage: 0,
    perPage: 0,
    totalProducts: 0,
    totalPages: 0

  });
  const [products, setProducts] = useState(null)

  // const fetchProducts = async (categorySlug, page) => {

  //   setProducts([]);
  //   const cacheKey = `${categorySlug}_${page}`;

  //   // If cache exists, use it
  //   if (productsCache[cacheKey]) {
  //     setProducts(productsCache[cacheKey].products);
  //     setPagination(productsCache[cacheKey].pagination);
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const response = await axios.get(`${Url}/api/v1/products/by-category-ptag?categorySlug=${categorySlug}&per_page=12&page=${page}`);
  //     const getAllProducts = response.data.products || [];
  //     const getPagination = response.data.pagination || {};

  //     // Set in state
  //     setProducts(getAllProducts);
  //     const newPagination = {
  //       currentPage: getPagination.currentPage,
  //       perPage: getPagination.perPage,
  //       totalProducts: getPagination.totalProducts,
  //       totalPages: getPagination.totalPages,
  //     };
  //     setPagination(newPagination);

  //     console.log(newPagination, "here is pagination")

  //     // Update cache
  //     setProductsCache(prev => ({
  //       ...prev,
  //       [cacheKey]: {
  //         products: getAllProducts,
  //         pagination: newPagination
  //       }
  //     }));
  //   } catch (error) {
  //     console.error("Failed to fetch data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchProducts = async (categorySlug, page, brand = [], stockStatus = null, sortBy = null) => {
    const token = sessionStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key
    };
    setProducts([]);
    // Normalize sortBy to a string value if it's an object (e.g. react-select)
    const sortByValue = sortBy && typeof sortBy === 'object' ? sortBy.value || null : sortBy;

    // include sortBy in cache key so different sorts cache separately
    const cacheKey = `${categorySlug}_${page}_${brand.join(',')}_${stockStatus}_${sortByValue || ''}`;


    // ✅ Check cache first
    if (productsCache[cacheKey]) {
      setProducts(productsCache[cacheKey].products);
      setPagination(productsCache[cacheKey].pagination);
      return;
    }

    setLoading(true);
    try {

      let apiUrl = `${Url}/api/v1/products/by-category-price-tags?categorySlug=${categorySlug}&per_page=12&page=${page}`;

      // ✅ Add brand filter
      if (brand.length > 0) {
        apiUrl += `&brand=${encodeURIComponent(brand.join(','))}`;
      }

      // ✅ Add stock filter
      if (stockStatus) {
        const stockValue = stockStatus === "inStock" ? 1 : 0; // assuming your API expects 1/0
        apiUrl += `&stockStatus=${stockValue}`;
      }

      if (sortBy) {
        apiUrl += `&sort_by=${sortBy}`;
      }

      const response = await axios.get(apiUrl, { headers: headers });
      const getAllProducts = response.data.products || [];
      const getPagination = response.data.pagination || {};

      const newPagination = {
        currentPage: getPagination.currentPage,
        perPage: getPagination.perPage,
        totalProducts: getPagination.totalProducts,
        totalPages: getPagination.totalPages,
      };

      setProducts(getAllProducts);
      setPagination(newPagination);

      // ✅ Cache result
      setProductsCache(prev => ({
        ...prev,
        [cacheKey]: {
          products: getAllProducts,
          pagination: newPagination,
        },
      }));
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleApplyFilter = async () => {
    if (!selectedSubCategory?.slug) {
      alert("Please select a subcategory first.");
      return;
    }

    // Reset pagination to first page when applying filters
    setCurrentPage(1);

    // Call fetchProducts with filters
    await fetchProducts(selectedSubCategory.slug, 1, selectedBrands, selectedStock, selectedSortingOption);
  };

  const handleClearBrandAndStock = async () => {
    // Reset only brand and stock filters
    setSelectedBrands([]);
    setSelectedStock(null);
    setSelectedSortingOption(null);

    // Keep the current subcategory and page
    setCurrentPage(1);

    // Fetch products with subcategory but without brand & stock filters
    await fetchProducts(selectedSubCategory?.slug, 1, [], null, null);
  };




  const [brandOptions, setBrandOptions] = useState([]);
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [isAdminBlock, setIsAdminBlock] = useState(false);

  const fetchCategoryFilters = async (categorySlug) => {
    try {
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };
      const res = await axios.get(`${Url}/api/v1/products/by-category/price-tags-filters?categorySlug=${categorySlug}`, { headers: headers });
      const brands = res.data?.filters?.brands?.map(b => b.name) || [];
      setIsAdminBlock(res.data?.is_admin);
      setBrandOptions(brands);
    } catch (err) {
      console.error("Error fetching price tag filters:", err);
    }
  };


  useEffect(() => {
    fetchPtagCategories();
    fetchMainCategories();
    fetchBannersMedia();
  }, []);


  const setselectedCategoryFN = async ({ name, uid, slug, subCategories }) => {
    setSelectedProducts([]);
    setSearchText("");
    setProducts([]);
    setProductsCache({})
    setSelectedCategory({
      name: name,
      uid: uid,
      slug: slug,
      subCategories: subCategories
    });
    await fetchSubCategories(uid)
  }

  const setSubCategorySelection = async ({ name, uid, slug }) => {
    setSelectedSubCategory({
      name: name,
      uid: uid,
      slug: slug
    });
    setSelectedProducts([]);
    setIsAllSelected(false);
    setSearchText("");
    await fetchCategoryFilters(slug);
    await fetchProducts(slug, 1);
    setCurrentPage(1);
  }

  const [isAllSelected, setIsAllSelected] = useState(false);

  const [selectedProducts, setSelectedProducts] = useState([]);

  function getFormattedOptionNames(array) {
    const labelsToInclude = selectedCategory.uid === 1
      ? ["Select Package"]
      : selectedCategory.uid === 2
        ? ["Select Size", "Select Package"]
        : ["Select Package"];

    const selectedNames = [];

    labelsToInclude.forEach(label => {
      const item = array.find(el => el.name === label);
      if (item && item.options && item.options.length > 0) {
        selectedNames.push(item.options[0].name);
      }
    });

    return selectedNames.join(" ");
  }

  function getFormattedData(data, indv) {
    const formattedData = [];
    console.log(indv);

    data?.forEach(element => {
      // Clone individuals for this product to avoid mutation across products
      const enhancedIndividuals = indv.map(item => ({
        ...item,
        p_name: "",
        p_uid: 0,
        p_price: ""
      }));

      console.log(element, "here isbelemeny")

      // Map collected_products and update matching enhancedIndividuals
      if (element.collected_products && element.collected_products.length > 0) {
        element.collected_products.forEach(collected => {
          if (collected.categories && collected.categories.length > 0) {
            collected.categories.forEach(category => {
              // Find the matching individual by slug
              const match = enhancedIndividuals.find(indvItem => indvItem.slug === category.slug);
              if (match) {
                match.image = collected.image;
                match.p_uid = collected.uid;
                match.p_name = collected.name;
                match.p_price = collected.sale_price || collected.regular_price || "";
                match.sku = collected.sku || collected.sku || "";
              }
            });
          }
        });
      }

      // Build product object
      const product = {
        uid: element.uid,
        name: element.name,
        landed_cost: element?.inventory?.landed_cost,
        fob_price: element?.inventory?.fob_price,
        sku: element.sku,
        image: Url + element?.image?.image_url,
        variations: [],
        individuals: enhancedIndividuals,
        collection_products: element?.collected_products
      };


      // Variations
      if (element.variations && element.variations.length > 0) {
        const seen = new Set();
        for (let i of element.variations) {
          const value = getFormattedOptionNames(i.attributes);
          if (!seen.has(value)) {
            seen.add(value);
            product.variations.push({
              value,
              sale_price: i.sale_price,
              regular_price: i.regular_price,
              fob_price: i?.inventory?.fob_price,
              landed_cost: i?.inventory?.landed_cost
            });
          }
        }
      } else {
        product.variations.push({
          value: getFormattedOptionNames(element.default_attributes),
          sale_price: element.sale_price,
          regular_price: element.regular_price,
          fob_price: element?.inventory?.fob_price,
          landed_cost: element?.inventory?.landed_cost
        });
      }


      formattedData.push(product);
    });

    console.log(formattedData, "formatted data");
    return formattedData;
  }


  function getFormattedSingleProduct(productData, indv) {
    console.log(indv);

    // Clone individuals for this product to avoid mutation
    const enhancedIndividuals = indv.map(item => ({
      ...item,
      p_name: "",
      p_uid: 0,
      p_price: ""
    }));

    // Map collected_products and update matching enhancedIndividuals
    if (productData.collected_products && productData.collected_products.length > 0) {
      productData.collected_products.forEach(collected => {
        if (collected.categories && collected.categories.length > 0) {
          collected.categories.forEach(category => {
            // Find the matching individual by slug
            const match = enhancedIndividuals.find(indvItem => indvItem.slug === category.slug);
            if (match) {
              match.p_uid = collected.uid;
              match.p_name = collected.name;
              match.p_price = collected.sale_price || collected.regular_price || "";
              match.sku = collected.sku;
            }
          });
        }
      });
    }

    // Build product object
    const product = {
      uid: productData.uid,
      name: productData.name,
      sku: productData.sku,
      image: Url + productData?.image?.image_url,
      variations: [],
      individuals: enhancedIndividuals,
      collection_products: productData?.collected_products
    };

    // Variations
    if (productData.variations && productData.variations.length > 0) {
      const seen = new Set();
      for (let i of productData.variations) {
        const value = getFormattedOptionNames(i.attributes);
        if (!seen.has(value)) {
          seen.add(value);
          product.variations.push({
            value,
            sale_price: i.sale_price,
            regular_price: i.regular_price
          });
        }
      }
    } else {
      product.variations.push({
        value: getFormattedOptionNames(productData.default_attributes),
        sale_price: productData.sale_price,
        regular_price: productData.regular_price
      });
    }

    console.log(product, "formatted single product");
    return product;
  }





  const handleToggleProduct = (item) => {
    setSelectedProducts((prev) => {
      const isAlreadySelected = prev.some((p) => p.uid === item.uid);

      if (isAlreadySelected) {
        // Remove the item
        return prev.filter((p) => p.uid !== item.uid);
      } else {
        // Add the item
        return [...prev, item];
      }
    });

    console.log(selectedProducts)
  };


  const [currentPage, setCurrentPage] = useState(null);

  const handlePageChange = async (pageNumber) => {
    setCurrentPage(pageNumber);
    await fetchProducts(selectedSubCategory.slug, pageNumber)

  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);

  };

  const handleNextPage = async () => {
    if (currentPage < pagination.totalPages) {
      const calledPage = currentPage + 1;
      setCurrentPage(calledPage)
      await fetchProducts(selectedSubCategory.slug, calledPage)
    };

  };

  // const generatePDF = () => {
  //   const doc = new jsPDF({
  //     orientation: "landscape",
  //     unit: "mm",
  //     format: "a4",
  //   });

  //   const loadImages = selectedProducts.map((item) => {
  //     return new Promise((resolve) => {
  //       const img = new Image();
  //       img.crossOrigin = "Anonymous";
  //       img.src = Url + item.image;
  //       img.onload = () => resolve(img);
  //     });
  //   });

  //   Promise.all(loadImages).then((images) => {
  //     // 2 rows, 2 columns
  //     const positions = [
  //       { x: 20, y: 20 },
  //       { x: 160, y: 20 },
  //       { x: 20, y: 110 },
  //       { x: 160, y: 110 }
  //     ];

  //     images.forEach((img, index) => {
  //       const pos = positions[index];
  //       doc.addImage(img, "PNG", pos.x, pos.y, 100, 80);
  //     });

  //     doc.save("4-images.pdf");
  //   });
  // };


  const bannerImages = [
    {
      id: 1,
      image: banner1
    },
    {
      id: 2,
      image: banner2
    }

  ];

  const [selectedBannerImage, setSelectedBannerImage] = useState(null)




  const [relatedCategories, setRelatedCategories] = useState([]);

  const fetchRelatedCategories = async (uid) => {
    const token = sessionStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key
    };
    setLoading(true);
    try {
      const response = await axios.get(`${Url}/api/v1/ptag/get-sub-cat?uid=${uid}`, { headers: headers });
      const getAllRelCategories = response.data.data || [];
      setRelatedCategories(getAllRelCategories.individuals);
      console.log(getAllRelCategories);
      return getAllRelCategories.individuals; // Return directly
    } catch (error) {
      console.error("Failed to fetch data:", error);
      return []; // Fallback if error occurs
    } finally {
      setLoading(false);
    }
  };










  const [showQuickView, setShowQuickView] = useState(null);

  const handleQuickViewProduct = async (item) => {
    let indv = [];

    if (selectedSubCategory?.uid) {
      try {
        const response = await fetchRelatedCategories(selectedSubCategory.uid);
        console.log("Fetched Individuals:", response);

        // If backend returns error message, just continue without stopping
        if (
          !response ||
          (response.message && response.message.includes("No subcategory found"))
        ) {
          console.warn("Subcategory not found — proceeding without related categories.");
        } else if (Array.isArray(response) && response.length > 0) {
          indv = response;
        }
      } catch (err) {
        console.error("Error fetching related categories:", err);
      }
    } else {
      console.warn("No subcategory selected — proceeding without fetching related categories.");
    }

    // Check selected products
    if (!selectedProducts || !Array.isArray(selectedProducts)) {
      console.error("selectedProducts is not defined or not an array.");
      setSubLoading(false);
      return;
    }
    console.log("Selected Products:", selectedProducts);

    // Format data
    const data = getFormattedSingleProduct(item, indv);
    console.log("Formatted Data:", data);

    if (!data || data.length === 0) {
      console.warn("Formatted data is empty.");
      setSubLoading(false);
      return;
    }

    // Show Quick View
    setShowQuickView(data);
  };



  // 0 --> frame I // 1 --> frame II // 2 --> frame 3
  const [selectedPattern_Blank, setSelectedPattern_Blank] = useState(0);

  const [selectedPattern_main, setSelectedPattern_main] = useState(null);

  const formatViews = {
    size1: {
      f1: {
        name: "Format I",
        value: "format_1_a",
        allowedFor: [],
        forall: true
      },
      f2: {
        name: "Format II",
        value: "format_2_a",
        allowedFor: [67,39],
        forall: false
      },
      lf1: {
        name: "Living Format I",
        value: "format_l1_a",
        allowedFor: [1],
        forall: false
      },
      fobf1: {
        name: "FOB Format I",
        value: "format_fob1_a",
        allowedFor: [],
        forall: true
      },
    },
    size2: {
      f1: {
        name: "Format I",
        value: "format_1_b",
        allowedFor: [2, 3, 4, 55],
        forall: false
      },
      f2: {
        name: "Format II",
        value: "format_2_b",
        allowedFor: [67, 39],
        forall: false
      },
      lf2: {
        name: "Living Format II",
        value: "format_l2_b",
        allowedFor: [1],
        forall: false
      },
    }
  }

  const isAllowed = (formatObj, selectedCategory) => {
    if (formatObj.forall) return true;
    return formatObj.allowedFor.includes(selectedCategory.uid);
  };




  const [totalPatterns, setTotalPatterns] = useState({

  });



  const [bannerImgForm, setBannerImgForm] = useState({
    image: null,
  });

  const [preview, setPreview] = useState(null);
  const [isBannerImgUploading, setIsBannerImageUploading] = useState(false);
  const [message, setMessage] = useState('');
  const fileInputRef = useRef();

  // Trigger file input
  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  // Handle image selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setBannerImgForm({ image: file });
      setPreview(URL.createObjectURL(file));
    }
  };

  // Submit form with image only
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!bannerImgForm.image) {
      return setMessage('Please upload an image.');
    }

    const data = new FormData();
    data.append('image', bannerImgForm.image); // Match multer field name
    setIsBannerImageUploading(true);
    try {
      const response = await axios.post(`${Url}/api/v1/media/price-tags/add`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setMessage(response.data.message);
      setBannerImgForm({ image: null })
      setPreview(null)
      await fetchBannersMedia()
      setIsBannerImageUploading(false);
      setSelectedViewBanner(0)
    } catch (error) {
      setMessage(error?.response?.data?.message || 'Upload failed.');
      setIsBannerImageUploading(false);
    }
  };






  const [selectedViewBanner, setSelectedViewBanner] = useState(0);
  const [dataSource, setDataSource] = useState("default");
  const [searchText, setSearchText] = useState("");

  const searchForProducts = async (text, page = 1) => {
    // setError(null);
    const api = `/api/v1/products/by-name?name=${text}&categorySlug=${selectedSubCategory.slug}&page=${page}&limit=50`;
    try {
      const response = await axios.get(Url + api);
      // setToastMessage("Sorted Products have been fetched successfully!");
      // setShowMessage(true);
      return response;
    } catch (error) {
      const errMsg = error?.response?.data?.message || error.message;
      // setError(errMsg);
      // setToastMessage(`Failed to fetch Sorted Products: ${errMsg}`);
      // setShowMessage(true);
      throw error;
    }
  };




  const handleSearch = async (searchValue, page = 1) => {
    if (!searchValue || searchValue.trim() === "") {
      setDataSource("default");
      setCurrentPage(1);

      // ✅ Fetch products of last selected category
      if (selectedSubCategory?.slug) {
        await fetchProducts(selectedSubCategory.slug, 1);
      }

      return;
    }

    setSearchText(searchValue);
    setDataSource("search");
    if (page === 1) setCurrentPage(1); // avoid infinite loop

    try {
      const response = await searchForProducts(searchValue, page);
      setProducts(response.data.products);
      // setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };


  const handleBrandSelect = (brand, isRemove = false) => {
    if (isRemove) {
      setSelectedBrands((prev) => prev.filter((b) => b !== brand));
    } else {
      setSelectedBrands((prev) => [...prev, brand]);
    }
  };











  return (
    <div className="priceTagsComponent">

      <div className="setting_btn_set" >



        <button className="pbt_button" onClick={() => {
          setShowPatternSelection2(true)
          // generatePDF3(1, selectedBannerImage?.image)
        }}>Print Blank Tags</button>

        <div className="setting_btn" onClick={() => {
          setShowBannerSelection(true)
        }}>
          <IoSettingsOutline />
        </div>
      </div>





      <div className="priceTagSection">
        {selectedBannerImage && <img onClick={() => { setShowBannerSelection(true) }} className="banner_to_show" src={Url + selectedBannerImage?.image_url} />}

        <h2>Product Categories</h2>
        <p>Select Category</p>
        <div className="mainCategories">
          {/* {
            categories && categories.map((item) => {
              return <div onClick={() => setselectedCategoryFN({ name: item.name, uid: item.uid, slug: item.slug })}>
                <CategoryCard name={item.name} slug={item.slug} uid={item.uid} selected={selectedCategory.uid === item.uid} />
              </div>
            })
          } */}

          {
            ptagCategoriesData && ptagCategoriesData.map((item) => {
              return <div onClick={() => setselectedCategoryFN({ name: item?.category?.name, uid: item?.category?.uid, slug: item?.category?.slug, subCategories: item?.subCategories })}>
                <CategoryCard name={item?.category?.name} slug={item?.category?.slug} uid={item?.category?.uid} selected={selectedCategory.uid === item?.category.uid} />
              </div>
            })
          }
        </div>

      </div>
      {selectedCategory?.subCategories.length > 0 && <div className="priceTagSection" style={{ marginTop: "20px" }}>
        <h2>Product Sub Categories</h2>
        <p>Select Category</p>
        <div className="mainCategories">
          {/* {
            subCategories && subCategories.map((item) => {
              return <div
                onClick={() => setSubCategorySelection({ name: item.name, uid: item.uid, slug: item.slug })}
              >
                <img className={item.uid === selectedSubCategory.uid ? "category_image selected" : "category_image"} src={Url + item.image2} />
              </div>
            })
          } */}
          {
            selectedCategory.subCategories.map((item) => {
              return <div onClick={() => setSubCategorySelection({ name: item?.name, uid: item?.uid, slug: item?.slug })}>
                <CategoryCard name={item?.name} slug={item?.slug} uid={item?.uid} selected={selectedSubCategory.uid === item?.uid} />
              </div>
            })
          }
        </div>
      </div>}



      {products && <div className="priceTagSection" style={{ marginTop: "20px" }}>
        <div className="header_pts">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
            <div className="leftSection_pts">
              <h2>Products</h2>
              <p>Select Products</p>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <SearchBar onSearch={handleSearch} icon={searchIcon} />
            </div>
          </div>


          <div className="buttons_section_pts">
            {selectedProducts.length > 0 && <p onClick={() => { setSelectedProducts([]); setIsAllSelected(false); }} >Unselect All</p>}
            <button
              className={isAllSelected ? "active" : ""}
              onClick={async () => {
                setLoading(true);
                setIsAllSelected(true);

                try {
                  const totalPages = pagination.totalPages;
                  let allProducts = [];

                  const fetchPromises = [];

                  for (let page = 1; page <= totalPages; page++) {
                    const cacheKey = `${selectedCategory.slug}_${selectedSubCategory.slug}_${page}`;

                    if (productsCache[cacheKey]) {
                      // Use cached products
                      allProducts = [...allProducts, ...productsCache[cacheKey].products];
                    } else {
                      // Prepare API call for pages not cached
                      const fetchPromise = axios
                        .get(`${Url}/api/v1/products/by-category-ptag?categorySlug=${selectedSubCategory.slug}&per_page=12&page=${page}`)
                        .then(response => {
                          const pageProducts = response.data.products || [];

                          // Save to cache
                          setProductsCache(prev => ({
                            ...prev,
                            [cacheKey]: {
                              products: pageProducts,
                              pagination: response.data.pagination || {},
                            },
                          }));

                          allProducts = [...allProducts, ...pageProducts];
                        })
                        .catch(err => {
                          console.error(`Error fetching page ${page}:`, err);
                        });

                      fetchPromises.push(fetchPromise);
                    }
                  }

                  // Wait for all fetches to complete
                  if (fetchPromises.length > 0) {
                    await Promise.all(fetchPromises);
                  }

                  // Now set selected products
                  setSelectedProducts(allProducts);

                } catch (error) {
                  console.error("Error selecting all products:", error);
                } finally {
                  setLoading(false); // Ensure loading is reset even if an error occurs
                }
              }}

            >
              Select All {pagination.totalProducts} Products
            </button>

            {selectedProducts.length > 0 ? <button onClick={() => {
              setShowPatternSelection(true)
              setSelectedPattern_main(null)

            }} className="print_pdf_button" >Print</button> : <div></div>}


          </div>

        </div>

      
        {brandOptions.length > 0 && (
          <div className="filterSection_ptag">
            <div style={{ display: "flex", gap: "10px" }}>
              <div className="priceTagSection_2" style={{ marginTop: "20px" }}>
                <p>Brand Filter</p>
                <SearchMultiple
                  label="Select Brands"
                  name="brandFilter"
                  placeholder="Search brands..."
                  options={brandOptions}
                  onSelect={handleBrandSelect}
                  selectedItems={selectedBrands}
                  minheight="40px"
                  width="400px"
                  suggestionListWidth="400px"
                  suggestionHeight="150px"
                />
              </div>

              <div className="priceTagSection_2" style={{ marginTop: "20px" }}>
                <p>Sort by</p>
                <CustomDropdown
                  options={statusTypeOptions}
                  selectedOption={selectedSortingOption}
                  handleOptionChange={(value) =>
                    setSelectedSortingOption(value)
                  }
                  borderRadius={"4px"}
                  dropdownWidth={195}
                  dropdownHeight={40}
                  optionsWidth={193}
                  arrowSize={17}
                  dropdownSelectedStyle="6px 8px"
                />
              </div>

              <div className="priceTagSection_2" style={{ marginTop: "20px" }}>
                <p>Stock Status</p>
                <CustomDropdown
                  options={stockOptions}
                  selectedOption={selectedStock}
                  handleOptionChange={(value) =>
                    setSelectedStock(value)
                  }
                  borderRadius={"4px"}
                  dropdownWidth={195}
                  dropdownHeight={40}
                  optionsWidth={193}
                  arrowSize={17}
                  dropdownSelectedStyle="6px 8px"
                />
              </div>


            </div>


            {(selectedStock !== null || selectedBrands.length > 0 || selectedSortingOption != null) &&
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", justifyContent: "flex-start", gap: "15px" }}>
                <span onClick={handleClearBrandAndStock} style={{ color: "#4478c5", cursor: "pointer", textDecoration: "underline" }}>Clear Filter</span>
                <button onClick={handleApplyFilter}>
                  Apply Filter
                </button>
              </div>

            }
          </div>
        )}

        <div className="productsSelection">
          {products &&
            products.map((item) => {
              const isSelected = selectedProducts.some((p) => p.uid === item.uid);

              return (
                <div key={item.uid}>
                  <ProductCard
                    fob_price={item?.inventory?.fob_price}
                    landedCost={item?.inventory?.landed_cost}
                    stock={item?.manage_stock?.stock_status}
                    qty={item?.inventory?.available}
                    name={item.name}
                    uid={item.uid}
                    slug={item.slug}
                    image={Url + item.image.image_url}
                    sku={item.sku}
                    selected={isSelected}
                    sale_price={item.sale_price}
                    regular_price={item.regular_price}
                    onClickFn={() => handleToggleProduct(item)}
                    onClickFn2={() => handleQuickViewProduct(item)}
                    showFobPrice={showFobPrice}
                    showLandedCost={showLandedCost}
                  />
                </div>
              );
            })}
        </div>
        <div className="bottom_bar_pts">
          <div className="first"></div>
          <Pagination
            activePageIndex={currentPage}
            totalPages={pagination.totalPages}
            onPrevPage={handlePrevPage}
            onNextPage={handleNextPage}
            onPageChange={handlePageChange}
          />
        </div>



      </div>}
      {showBannerSelection && 
      
      <div className="backdrop">
        <div className="select_banner_ptag">
          <div>
            <button className="close_btn_product" onClick={() => { setShowBannerSelection(false) }} ><RxCross1 /></button>
          </div>

          <h2>Banner</h2>

          <div className="tab_section_main">
            <div className={selectedViewBanner === 0 ? "tab_section active" : "tab_section"} onClick={() => {
              setSelectedViewBanner(0)
            }}>
              Select Banner
            </div>
            <div className={selectedViewBanner === 1 ? "tab_section active" : "tab_section"} onClick={() => {
              setSelectedViewBanner(1)
            }}>
              Upload Banner
            </div>
          </div>

          {selectedViewBanner === 1 && <div style={{ margin: 'auto', marginTop: "20px", position: "relative" }}>
            {preview ? <div></div> : <div
              className="close_btn_product_upload"
              style={{}}
              onClick={handleFileClick}
            >
              <FiUpload /> Upload Image
            </div>}

            {/* Hidden file input */}
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleImageChange}
            />

            {/* Image preview */}
            {preview && <img src={preview} className="selected_uploaded_banner" alt="Preview" style={{ marginBottom: '10px' }} />}
            {/* Submit button */}
            {preview && <form onSubmit={handleSubmit} encType="multipart/form-data">
              <button className="upload_image_btn_pop" type="submit">{isBannerImgUploading ? <div style={{ borderTop: "4px solid var(--Dark-Blue)" }} className="btn-loader-Publish"></div> : "Upload"}</button>
            </form>}

            {
              preview && <div className="remove_uploaded_banner_img" onClick={() => { setPreview(null); setBannerImgForm({ image: null }) }} ><RxCross1 /></div>
            }
          </div>}


          {selectedViewBanner === 0 && <div className="banners_list">
            {/* {bannerImages.map((item) => (
              <div
                key={item.id}
                className={`banner_image ${selectedBannerImage?.id === item.id ? "active" : ""}`}
                onClick={() => setSelectedBannerImage(item)}
              >
                <img src={item.image} alt={`Banner ${item.id}`} />
              </div>
            ))} */}
            {

              bannersMedia.map((item) => (
                <div
                  key={item._id}
                  className={`banner_image ${selectedBannerImage?._id === item._id ? "active" : ""}`}
                  onClick={() => setSelectedBannerImage(item)}
                >
                  <img src={Url + item.image_url} alt={`Banner ${item._id}`} />
                </div>
              ))
            }
          </div>}


          <div className="bottom_bar_popup">
            <button className="updt_btn" onClick={() => {
              setShowBannerSelection(false);
            }}>Okay</button>
          </div>
        </div>
      </div>}

      {showPatternSelection && <div className="backdrop">
        <div className="select_pdf_format">
          <button className="close_btn_product" onClick={() => { setShowPatternSelection(false) }} ><RxCross1 /></button>
          <h2>Select Price Tag Design</h2>

          <div className="format_selection_view">
            <div className="ptags_designs_header">
              <p>Use US Ledger Layout (17 x 11 inches)</p>
              <div className="buttons_Set_for_2">
                <div
                  onClick={() => canScrollLeft && handleScroll("left")}
                  className={`arrow_btn_pdh lft ${!canScrollLeft ? "disabled" : ""}`}
                >
                  <IoChevronBack />
                </div>
                <div
                  onClick={() => canScrollRight && handleScroll("right")}
                  className={`arrow_btn_pdh rgh ${!canScrollRight ? "disabled" : ""}`}
                >
                  <IoChevronForward />
                </div>
              </div>

            </div>


            <div className="ptags_designs " ref={scrollRef_2}>
              <div
                onClick={() => {
                  if (isAllowed(formatViews.size1.f1, selectedCategory)) {
                    setSelectedPattern_main(formatViews.size1.f1.value);
                  }
                }}
                className={
                  selectedPattern_main === formatViews.size1.f1.value
                    ? "template_ptag selected"
                    : isAllowed(formatViews.size1.f1, selectedCategory)
                      ? "template_ptag"
                      : "template_ptag disabled"
                }
              >
                <div className="design_ptag">
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                </div>
                <h3>Format I (17W x 11H)</h3>
              </div>

              <div
                onClick={() => {
                  if (isAllowed(formatViews.size1.lf1, selectedCategory)) {
                    setSelectedPattern_main(formatViews.size1.lf1.value);
                  }
                }}
                className={
                  selectedPattern_main === formatViews.size1.lf1.value
                    ? "template_ptag selected"
                    : isAllowed(formatViews.size1.lf1, selectedCategory)
                      ? "template_ptag"
                      : "template_ptag disabled"
                }
              >
                <div className="design_ptag fourl">
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  
                </div>
                <h3>Living Format I (11W x 17H)</h3>
              </div>
              <div
                 onClick={() => {
                  if (isAllowed(formatViews.size1.f2, selectedCategory)) {
                    setSelectedPattern_main(formatViews.size1.f2.value);
                  }
                }}
                className={
                  selectedPattern_main === formatViews.size1.f2.value
                    ? "template_ptag selected"
                    : isAllowed(formatViews.size1.f2, selectedCategory)
                      ? "template_ptag"
                      : "template_ptag disabled"
                }

               
              >
                <div className="design_ptag four" style={{}}>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                </div>
                <h3>Format II  (11W x 17H)</h3>
              </div>
              {isAdminBlock && <div onClick={() => {
                if (isAllowed(formatViews.size1.fobf1, selectedCategory)) {
                  setSelectedPattern_main(formatViews.size1.fobf1.value);
                }
              }}
                className={
                  selectedPattern_main === formatViews.size1.fobf1.value
                    ? "template_ptag selected"
                    : isAllowed(formatViews.size1.fobf1, selectedCategory)
                      ? "template_ptag"
                      : "template_ptag disabled"
                }>
                <div className="design_ptag">
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                </div>
                <h3>FOB Format I (17W x 11H)</h3>
              </div>}
            </div>

          </div>

          <div className="format_selection_view">
            <div className="ptags_designs_header">
              <p>Use US Letter Layout (8.5 x 11 inches)</p>

            </div>
            <div className="ptags_designs">
              <div
                onClick={() => {
                  if (isAllowed(formatViews.size2.f1, selectedCategory)) {
                    setSelectedPattern_main(formatViews.size2.f1.value);
                  }
                }}
                className={
                  selectedPattern_main === formatViews.size2.f1.value
                    ? "template_ptag selected"
                    : isAllowed(formatViews.size2.f1, selectedCategory)
                      ? "template_ptag"
                      : "template_ptag disabled"
                }
              >
                <div className="design_ptag twol">
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  {/* <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div> */}
                </div>
                <h3>Format I (8.5W x 11H)</h3>
              </div>
               <div onClick={() => {
                if (isAllowed(formatViews.size2.lf2, selectedCategory)) {
                  setSelectedPattern_main(formatViews.size2.lf2.value);
                }
              }}
                className={
                  selectedPattern_main === formatViews.size2.lf2.value
                    ? "template_ptag selected"
                    : isAllowed(formatViews.size2.lf2, selectedCategory)
                      ? "template_ptag"
                      : "template_ptag disabled"
                }>
                <div className="design_ptag two">
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                </div>
                <h3>Living Format II (11W x 8.5H)</h3>
              </div>
              <div onClick={() => {
                if (isAllowed(formatViews.size2.f2, selectedCategory)) {
                  setSelectedPattern_main(formatViews.size2.f2.value);
                }
              }}
                className={
                  selectedPattern_main === formatViews.size2.f2.value
                    ? "template_ptag selected"
                    : isAllowed(formatViews.size2.f2, selectedCategory)
                      ? "template_ptag"
                      : "template_ptag disabled"
                }>
                <div className="design_ptag fourl">
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                  <div className="ptag_box_4x4"></div>
                </div>
                <h3>Format II (8.5W x 11H)</h3>
              </div>
             
            </div>
          </div>
          <div className="bottom_bar_popup">
            <button
              disabled={selectedPattern_main === null}
              className="updt_btn"
              onClick={async () => {
                try {
                  setShowPatternSelection(false);
                  setSubLoading(true);

                  let indv = [];

                  // Step 1: Fetch related individuals only if subcategory exists
                  if (selectedSubCategory?.uid) {
                    try {
                      const response = await fetchRelatedCategories(selectedSubCategory.uid);
                      console.log("Fetched Individuals:", response);

                      if (
                        !response ||
                        (response.message &&
                          response.message.includes("No subcategory found"))
                      ) {
                        console.warn("Subcategory not found — proceeding without related categories.");
                      } else if (Array.isArray(response) && response.length > 0) {
                        indv = response;
                      }
                    } catch (fetchError) {
                      console.error("Error fetching related categories:", fetchError);
                    }
                  } else {
                    console.warn("No subcategory selected — proceeding without related categories.");
                  }

                  // Step 2: Check selected products
                  if (!selectedProducts || !Array.isArray(selectedProducts)) {
                    console.error("selectedProducts is not defined or not an array.");
                    setSubLoading(false);
                    return;
                  }
                  console.log("Selected Products:", selectedProducts);
                  console.log("indv ", indv)
                  // Step 3: Format data
                  const data = getFormattedData(selectedProducts, indv);
                  console.log("Formatted Data:", data);

                  if (!data || data.length === 0) {
                    console.warn("Formatted data is empty.");
                    setSubLoading(false);
                    return;
                  }

                  // Step 4: Generate PDF
                  if (selectedPattern_main === 'format_1_b') {
                    await generatePDFOpt2(data, Url + selectedBannerImage?.image_url);
                    setSelectedProducts([]);
                    setIsAllSelected(false);
                  } else if (selectedPattern_main === 'format_1_a') {
                    await generatePDF(data, Url + selectedBannerImage?.image_url);
                    // await generatePDFWithoutFinanceBox(data, Url + selectedBannerImage?.image_url);
                    setSelectedProducts([]);
                    setIsAllSelected(false);

                  } else if (selectedPattern_main === 'format_fob1_a') {
                    // await generatePDF(data, Url + selectedBannerImage?.image_url);
                    await generatePDFWithoutFinanceBox(data, Url + selectedBannerImage?.image_url);
                    setSelectedProducts([]);
                    setIsAllSelected(false);

                  } else if (selectedPattern_main === 'format_2_b') {
                    await generatePDFOpt2_TwoCols(data, Url + selectedBannerImage?.image_url);
                    setSelectedProducts([]);
                    setIsAllSelected(false);

                  }
                  else if (selectedPattern_main === 'format_2_a') {
                    // await generatePDFOpt2_TwoCols(data, Url + selectedBannerImage?.image_url);

                    await generatePDFOpt4_TwoCols_2(data, Url + selectedBannerImage?.image_url);
                    setSelectedProducts([]);
                    setIsAllSelected(false);

                  }
                  else if (selectedPattern_main === 'format_l2_b') {
                    await generatePDFOpt3_TwoCols_2(data, Url + selectedBannerImage?.image_url);
                    setSelectedProducts([]);
                    setIsAllSelected(false);
                    setSelectedPattern_main(null);

                  }

                  else if (selectedPattern_main === 'format_l1_a') {
                    // await generatePDFOpt4_TwoCols_2(data, Url + selectedBannerImage?.image_url);
                    // setSelectedProducts([]);
                    // setIsAllSelected(false);
                    // setSelectedPattern_main(null);

                     await generatePDFOpt3_TwoCols(data, Url + selectedBannerImage?.image_url);
                    setSelectedProducts([]);
                    setIsAllSelected(false);

                  }


                } catch (error) {
                  console.error("Error in onClick handler:", error);
                } finally {
                  setSubLoading(false);
                }
              }


              }

            >
              Proceed
            </button>

          </div>
        </div>
      </div>}



      {showPatternSelection2 && <div className="backdrop">
        <div className="select_pdf_format">
          <button className="close_btn_product" onClick={() => { setShowPatternSelection2(false) }} ><RxCross1 /></button>
          <h2>Select Price Tag Design</h2>
          <div className="ptags_designs ">
            <div onClick={() => { setSelectedPattern_Blank(0) }} className={`template_ptag ${selectedPattern_Blank === 0 ? "selected" : ""}`}>
              <div className="design_ptag" style={{ width: "240px", gap: "5px" }}>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
              </div>
              <h3>Format I  (17W x 11H)</h3>
            </div>
            <div onClick={() => { setSelectedPattern_Blank(1) }} className={`template_ptag ${selectedPattern_Blank === 1 ? "selected" : ""}`}>
              <div className="design_ptag four">
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
              </div>
              <h3>Format II  (17W x 11H)</h3>
            </div>
            <div onClick={() => { setSelectedPattern_Blank(2) }} className={`template_ptag ${selectedPattern_Blank === 2 ? "selected" : ""}`}>
              <div className="design_ptag">
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
                <div className="ptag_box_4x4"></div>
              </div>
              <h3>Format III  (17W x 11H)</h3>
            </div>
          </div>
          <div className="bottom_bar_popup">
            <button
              className="updt_btn"
              onClick={async () => {
                if (selectedPattern_Blank === 0) {
                  generatePDF1(1, Url + selectedBannerImage?.image_url)
                  setShowPatternSelection2(false);
                } else if (selectedPattern_Blank === 1) {
                  generatePDF2(1, Url + selectedBannerImage?.image_url)
                  setShowPatternSelection2(false);
                } else if (selectedPattern_Blank === 2) {
                  generatePDF3(1, Url + selectedBannerImage?.image_url)
                  setShowPatternSelection2(false);
                } else {
                  setShowPatternSelection2(false);
                }

              }}

            >
              Proceed
            </button>

          </div>
        </div>
      </div>}


      {showQuickView && <div className="backdrop">
        <div className="quick_view_ptag">
          <div className="header_pt_qv">
            <img src={selectedBannerImage.image} />
          </div>
          <div className="body_pt_qv">
            <div className="left_pt_qv">
              <div className="left_pt_qv_top">
                <p style={{ color: "#288EA9" }} className="paragraph1_ptag">{showQuickView?.variations[0]?.value}</p>
                <h3 style={{ color: "#000" }} className="heading3_ptag">was ${showQuickView?.variations[0]?.regular_price}</h3>
                <h1 style={{ color: "#FC0000" }} className="heading1_ptag">${showQuickView?.variations[0]?.sale_price}</h1>
              </div>
              <div className="left_pt_qv_bottom">
                {showQuickView?.variations.length > 1 && <p style={{ color: "#000" }} className="paragraph1_ptag">Group Pricing</p>}

                {showQuickView?.variations.length > 1 &&
                  showQuickView?.variations.slice(1).map((item) => (
                    <p style={{ color: "#000", marginTop: "7px", fontWeight: "800" }} className="paragraph2_ptag">
                      {item.value} <span className="paragraph2_ptag" style={{ color: "#FC0000", fontWeight: "800" }}>${item.sale_price}</span>
                    </p>
                  ))
                }


              </div>
            </div>
            <div className="right_pt_qv">
              <div className="right_pt_qv_top">
                <img src={showQuickView.image} />
                <div className="details_right_pt_qv">
                  <p style={{ color: "#000", fontStyle: "normal", fontWeight: "800", fontSize: "14px" }} className="paragraph1_ptag">{showQuickView.name}</p>
                  <p style={{ color: "#000", fontStyle: "normal", fontWeight: "500", fontSize: "16px" }} className="paragraph1_ptag">MODEL# {showQuickView.sku}</p>
                </div>
              </div>
              <div className="right_pt_qv_bottom">
                <div className="right_pt_qv_bottom_variations">
                  {[
                    ...showQuickView?.individuals,
                    ...Array.from({ length: Math.max(8 - (showQuickView?.individuals?.length || 0), 0) }).map(() => ({
                      inputValue: "",
                      p_price: "",
                      _id: Math.random().toString(36).substr(2, 9) // fake key to avoid duplicate keys
                    }))
                  ].map((item, index) => (
                    <React.Fragment key={item._id || index}>
                      <div style={{ color: '#000' }} className="right_pt_qv_bottom_variations_box">
                        {item.inputValue || ""}
                      </div>
                      <div style={{ color: '#FC0000' }} className="right_pt_qv_bottom_variations_box">
                        {item.p_price && "$"}{item.p_price || ""}
                      </div>
                    </React.Fragment>
                  ))}
                </div>


                <div className="right_pt_qv_bottom_installment">
                  <h2 style={{ color: "#FC0000" }} className="heading2_ptag">${getAdjustedPrice(showQuickView?.variations[0]?.sale_price)}<span style={{
                    color: "#288EA9",
                    fontSize: "16px",
                    fontStyle: "normal",
                    fontWeight: "600"
                  }}>/week</span></h2>

                  <p style={{ color: "#974483", fontStyle: "normal", fontWeight: "500" }} className="paragraph1_ptag">Subject to approval. some restrictions apply</p>
                  <p style={{ color: "#88C257", fontStyle: "normal", fontWeight: "600", fontSize: "24px" }} className="paragraph1_ptag">NO CREDIT 0 DOWN</p>
                  <p style={{ color: "#387097", fontStyle: "normal", fontWeight: "700", fontSize: "18px" }} className="paragraph1_ptag">100 DAYS NO INTEREST</p>
                </div>
              </div>
            </div>
          </div>
          <div className="close_btn_pt_qv" onClick={() => { setShowQuickView(null) }}>
            <IoClose size={20} />
          </div>
        </div>
      </div>}

      {subLoading && <div className="backdrop">
        <div className="loader-container">
          <MainLoader heading1={"Generating Ptags..."} />
        </div>
      </div>}

      {loading && <div className="backdrop">
        <div className="loader-container">
          <MainLoader heading1={"Please Wait..."} />
        </div>
      </div>}


    </div>
  );
};

export default PriceTags;